import { writable } from 'svelte/store'

import { makeAccTemplate } from './factories'


const store = writable(makeAccTemplate())

export { store as account_template_store }



